// components
import { Container } from 'components/Grid';
import { MirandaGradientButton } from '@/components/Button';

// styles
import {
  PageWrapper,
  Title,
  Tag,
  CTAWrapper,
} from './BackgroundImageSectionEarly.styles';

export const BackgroundImageSectionEarly = ({ content }) => {
  return (
    <PageWrapper bg={content.image}>
      <Container>
        {content.tag ? <Tag>{content.tag}</Tag> : ''}
        <Title>{content.title}</Title>

        {content.CTA && (
          <CTAWrapper>
            <MirandaGradientButton
              as="a"
              href={content.CTA.link}
              target={content.CTA.external ? `_blank` : ``}
              rel={content.CTA.external ? `noreferrer noopener` : ``}
            >
              <span>{content.CTA.label}</span>
            </MirandaGradientButton>
          </CTAWrapper>
        )}
      </Container>
    </PageWrapper>
  );
};
